import React from 'react';
import {Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Weaknesses from "../../../../components/charts/Weakness";

export default function WeaknessExport({weaknessesData}) {
    return (
        <Box sx={{ bgcolor: "#f9f9f9"}}>
            <Box
                key={1}
                id={`tlm-threat-1`} // Unique ID for each threat
                sx={{
                    width: "210mm", // A4 width
                    height: "auto", // A4 height
                    minHeight: "210mm",
                    margin: "auto", // Center the box horizontally
                    marginBottom: "20px",
                    pageBreakAfter: "always", // Ensure each box starts on a new page in the PDF
                    boxShadow: 3,
                    borderRadius: 2,
                    bgcolor: "#f9f9f9",
                    padding: "20px", // Add padding inside the box
                    boxSizing: "border-box", // Include padding in the total width/height
                    overflow: "hidden", // Prevent content from overflowing

                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {/* Threat Title */}
                <Typography
                    sx={{
                        textAlign: "center",
                        fontSize: {xs: "32px", sm: "40px"}, // Increased font size
                        fontWeight: "bold",
                        marginBottom: "20px", // Increased spacing
                    }}
                >
                    Threat Loss Magnitude
                </Typography>

                {/* Weaknesses Graph Container */}
                <Box
                    sx={{
                        width: "100%", // Take full width of the parent container
                        height: "80%", // Allocate 80% of the height for the chart
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: 3,
                        borderRadius: 2,
                        paddingTop: 3,
                        bgcolor: "background.paper",
                        overflow: "hidden", // Ensure the chart doesn't overflow
                    }}
                >
                    <Weaknesses
                        data={weaknessesData}
                        type="doughnut"
                        title="Security Weaknesses"

                    />
                </Box>
            </Box>
        </Box>
    );
}